// src/context/SettingsContext.js
import React, { createContext, useState, useEffect, useContext } from 'react';

const SettingsContext = createContext();

export const useSettings = () => useContext(SettingsContext);

export const SettingsProvider = ({ children }) => {
  
  const [globalSettings, setGlobalSettings] = useState(() => {
    const saved = localStorage.getItem('appSettings');
    return saved ? JSON.parse(saved) : {
      companyName: 'Iconic Green Land',
      primaryColor: '#4f46e5',
      logo: null 
    };
  });

  // 
  useEffect(() => {
    document.documentElement.style.setProperty('--primary', globalSettings.primaryColor);
  }, [globalSettings.primaryColor]);

  
  const updateSettings = (newSettings) => {
    setGlobalSettings((prev) => {
      const updated = { ...prev, ...newSettings };
      localStorage.setItem('appSettings', JSON.stringify(updated)); // Save to Storage
      return updated;
    });
  };

  return (
    <SettingsContext.Provider value={{ globalSettings, updateSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};